import * as React from 'react'
export function LinkedinShared({ title, height = 20, width = 21, ...props }) {
  return (
    <div style={{ width, height }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="110%" height="110%" fill="none" {...props}>
        <title>{title}</title>
        <path
          fill="#1D252F"
          d="M2.395.477c-.579 0-1.11.215-1.5.605A2.1 2.1 0 0 0 .29 2.584a2.122 2.122 0 0 0 .605 1.519 2.03 2.03 0 0 0 1.454.586c.617 0 1.152-.209 1.546-.605.386-.386.598-.92.597-1.502V2.58C4.483 1.36 3.602.476 2.395.476v.001ZM4.173 6.154H.608v13.37h3.565V6.153ZM18.763 7.16C17.471 6 15.961 5.828 15.174 5.828c-1.987 0-3.478.872-4.408 1.876l-.095-1.55H7.397l.031.513c.059.996.119 2.23.119 3.845v9.013h3.564v-7.188c0-.365.06-.78.154-1.054l.002-.007c.373-1.165 1.463-2.34 3.053-2.34 2.34 0 2.83 2.053 2.83 3.775v6.814h3.565v-7.1c0-2.334-.655-4.104-1.949-5.263l-.003-.002Z"
        />
      </svg>
    </div>
  )
}
export default LinkedinShared
